import { getStoreId } from "$/hooks/use-store-information"
import leadTimeQueries from "$/lib/queries/lead-time-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/lead-time")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(leadTimeQueries.all(storeId))
    }

    return {
      crumb: "alfred.settings.nav.leadTime.label",
    }
  },
})
